import styled from 'styled-components'
import { MapWrapper } from './MapWrapperWithTable/style'

const defaultHeaderHeight = 70
const defaultFooterHeight = 70
const defaultSidebarWidth = 400

export const FullPageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  ${({ headerHeight=defaultHeaderHeight, footerHeight=defaultFooterHeight }) => {
    return `margin: ${headerHeight}px 0 ${footerHeight}px 0;`
  }}
  overflow: hidden;
`

export const MapSidebar = styled.div`
  width: ${({ width=defaultSidebarWidth }) => {
    return width
  }}px;
  flex: 0 0 auto;
  height: 100%;
  padding: 12px;
  overflow: auto;
`

export const SidebarSeparator = styled.div`
    hr {
        border-top: 1px solid rgba(32, 32, 32, 0.1);
    }
    box-shadow: 0px 1px 2px rgb(32 32 32 / 5%);
`

export const DummyMapWrapper = styled(MapWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #eee;
`
export const MapLoadingTitle = styled.div`
  margin: 24px 0 8px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`
